import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

const BlankCell = () => {
  return (
    <Box
      flexDirection="row"
      width="full"
      height="s24"
      background="grey200"
      borderRadius={{
        all: 'abs008',
      }}
      justifyContent="center"
      alignItems="center"
    >
      -
    </Box>
  )
}

export default BlankCell
